import { useContext, useState } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';

function useUpdatePaymentInstrument() {
  const [fault, setFault] = useState(null);
  const [interactionData, setInteractionData] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const [loading, setLoading] = useState(null);
  const WebApi = useContext(WebApiContext);

  const requestUpdatePaymentInstrument = (newRequestData) => {
    setFault(null);
    setLoading(true);
    WebApi.subscriber({
      callName: 'UpdatePaymentInstrument',
      keyFactors: ['UpdatePaymentInstrument'],
      forceRefresh: true,
      payload: newRequestData,
    })
      .then((response) => {
        setLoading(false);
        const updateAddress = response.data;
        setUiModel(updateAddress);
      })
      .catch((error) => {
        setLoading(false);
        console.warn({ error });
        const code = error?.data?.Code;
        const faultData = error?.data;
        const errorMessagesHeading = 1000;
        const unknownError = 1001;
        let errorMsg;
        if (code !== 635) {
          setInteractionData({
            description: 'Web: Update Payment Instrument Failed',
            errorStack: error,
          });
        }
        setFault('');
        const faultCodeGenerate = (data, subCode) => ({
          ...data,
          faultCode: `${data?.faultCode.split('-')[0]}-${subCode}`,
        });
        if (!code) {
          const unknownFault = generateUnhandledFault(error.data);
          errorMsg = translateFault(unknownFault).translatedMessage;
          setFault(errorMsg);
        } else {
          const dataCode =
            error?.data?.Code === 118 || error?.data?.Code === 606;
          if (dataCode) {
            const faultNodeErrorMessageHeading = faultCodeGenerate(
              error.data,
              errorMessagesHeading,
            );
            const faultNodeUnknownError = faultCodeGenerate(
              error.data,
              unknownError,
            );
            errorMsg = `${
              translateFault(faultNodeErrorMessageHeading).translatedMessage
            }-${translateFault(faultNodeUnknownError).translatedMessage}`;
          } else {
            errorMsg = translateFault(error.data).translatedMessage;
          }
          if (code === 635) {
            setFault({ Fault: { ...faultData, faultMessage: errorMsg } });
            return;
          }
          setFault(errorMsg);
        }
      });
  };
  return [
    uiModel,
    fault,
    loading,
    requestUpdatePaymentInstrument,
    interactionData,
  ];
}

export { useUpdatePaymentInstrument };
export default useUpdatePaymentInstrument;
